import axiosInstance from './axiosInstance';

export const createSlip = (request) => axiosInstance.post("/CommissionSlip/CreateSlip", request);
export const getPendingApprovals = () => axiosInstance.get("/CommissionSlip/GetPendingApprovals");
export const getPendingCount = () => axiosInstance.get("/CommissionSlip/GetPendingCount");
export const getMySlips = () => axiosInstance.get("/CommissionSlip/GetMySlips");
export const getAllSlips = () => axiosInstance.get("/CommissionSlip/GetAllSlips");
export const approveSlip = (slipId) => axiosInstance.put("/CommissionSlip/ApproveSlip", { slipId });
export const rejectSlip = (slipId, remarks) => axiosInstance.put("/CommissionSlip/RejectSlip", { slipId, remarks });
export const getSlipsByAgent = (agentId) => axiosInstance.get(`/CommissionSlip/GetSlipsByAgent?agentId=${agentId}`);
export const bulkGenerateSlips = (month, year) => axiosInstance.post("/CommissionSlip/BulkGenerate", { month, year });
export const voidSlip = (slipId, remarks) => axiosInstance.put("/CommissionSlip/VoidSlip", { slipId, remarks });
export const exportMakerCsv = (slipIds) =>
    axiosInstance.get(`/CommissionSlip/ExportMakerCsv?slipIds=${slipIds.join(',')}`);
export const getSlipById = (slipId) => axiosInstance.get(`/CommissionSlip/GetSlipById?slipId=${slipId}`);
